import { OrgManagePage } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 机构管理（运营端本租户，门禁 sys:org:manage）。
 * 页面实现收敛在 `@hq/org-admin`，本端关闭租户维度（新建机构跟随令牌租户）。
 */
export default function OrgManage() {
  return <OrgManagePage hq={hq} />;
}
